import { render, staticRenderFns } from "./EventProfileTab.vue?vue&type=template&id=64572a85&scoped=true&"
import script from "./EventProfileTab.vue?vue&type=script&lang=js&"
export * from "./EventProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64572a85",
  null
  
)

export default component.exports